const accordion = [
    {
        selector: '[data-js=accordion]',
        path: { filename: 'accordion' },
    },
];

export { accordion };
